import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Input from "../../../controls/Input";
import TextArea from "../../../controls/TextArea";
import DeleteConfirmationForm from "../../DeleteConfirmationForm";

function ViewGmgProductSlideOverContent({ setOpen, initialData }) {
  const data = initialData ?? {};

  return (
    <div className="hide-for-print flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll p-6">
        <div className="flex-1">
          <h2 className="text-base font-semibold leading-6 text-gray-900">
            View GMG Product
          </h2>
          <div className="mt-4 space-y-4">
            <Input
              label="PLU"
              name="chintai_plu"
              value={data.chintai_plu ?? ""}
              labelOn={true}
              disabled={true}
              parentClass="w-full"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Name"
              name="chintai_product_name"
              value={data.chintai_product_name ?? ""}
              labelOn={true}
              disabled={true}
              parentClass="w-full"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Name (CH)"
              name="chintai_product_name_ch"
              value={data.chintai_product_name_ch ?? ""}
              labelOn={true}
              disabled={true}
              parentClass="w-full"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <TextArea
              label="Description"
              name="chintai_product_description"
              value={data.chintai_product_description ?? ""}
              labelOn={true}
              disabled={true}
              rows={3}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Class"
              name="chintai_class_name"
              value={data.chintai_class_name ?? ""}
              labelOn={true}
              disabled={true}
              parentClass="w-full"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Category"
              name="chintai_category_name"
              value={data.chintai_category_name ?? ""}
              labelOn={true}
              disabled={true}
              parentClass="w-full"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Colour"
              name="chintai_colour_name"
              value={data.chintai_colour_name ?? ""}
              labelOn={true}
              disabled={true}
              parentClass="w-full"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Odour"
              name="chintai_odour_name"
              value={data.chintai_odour_name ?? ""}
              labelOn={true}
              disabled={true}
              parentClass="w-full"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Taste"
              name="chintai_taste_name"
              value={data.chintai_taste_name ?? ""}
              labelOn={true}
              disabled={true}
              parentClass="w-full"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
        </div>
          <div className="mt-6 flex justify-end border-t border-gray-200 pt-4">
            <button
              type="button"
              className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              onClick={() => setOpen({ childComponent: null, open: false })}
            >
              Close
            </button>
          </div>
        </div>
    </div>
  );
}

const CONFIRM_MESSAGES = {
  1: "Are you sure you want to take your PLU?",
  2: "Are you sure you want to take Alex's PLU?",
  3: "Are you sure you want to ignore?",
};

export default function ProductDuplicates(props) {
  const { product, productDuplicates, setSlideOver, setEmptyModelOpen, updateProductDuplicate } = props;

  const openViewGmgProductSlideOver = (rowData) => {
    if (!setSlideOver) return;
    setSlideOver({
      open: true,
      childComponent: (
        <ViewGmgProductSlideOverContent setOpen={setSlideOver} initialData={rowData} />
      ),
    });
  };

  const handleUpdateStatus = (rowData, new_status) => {
    if (!updateProductDuplicate || !setEmptyModelOpen || rowData.id == null) return;
    const message = CONFIRM_MESSAGES[new_status];
    if (!message) return;
    setEmptyModelOpen({
      open: true,
      childComponent: (
        <DeleteConfirmationForm
          title="Confirm"
          message={message}
          buttonMessage="Confirm"
          hideReason={true}
          setOpen={setEmptyModelOpen}
          confirmAction={async () => {
            await updateProductDuplicate(rowData.id, new_status);
            setEmptyModelOpen({ childComponent: null, open: false });
          }}
        />
      ),
    });
  };

  const viewGmgProductBody = (rowData) => {
    return (
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
          onClick={() => openViewGmgProductSlideOver(rowData)}
        >
          View GMG Product
        </button>
        <button
          type="button"
          className="rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
          onClick={() => handleUpdateStatus(rowData, 1)}
        >
          Take my PLU
        </button>
        <button
          type="button"
          className="rounded-md bg-cyan-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-cyan-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600"
          onClick={() => handleUpdateStatus(rowData, 2)}
        >
          Take Alex PLU
        </button>
        <button
          type="button"
          className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          onClick={() => handleUpdateStatus(rowData, 3)}
        >
          Ignore
        </button>
      </div>
    );
  };

  const bodyChintaiPlu = (rowData) => {
    return (
      <div
      >
        <p>{rowData.chintai_plu}</p>
        <p>{rowData.chintai_product_name}</p>
        <p>{rowData.chintai_product_name_ch}</p>
      </div>
    );
  }

    const gmgHoPlu = (rowData) => {
      return (
        <div
        >
          <p>{rowData.gmg_ho_plu}</p>
          <p>{product.name}</p>
        </div>
      );
    }

  return (
    <div className="px-2 py-4">
        <div className="overflow-hidden card-custom">
          <DataTable
            value={productDuplicates}
            emptyMessage="No product duplicates found"
            stripedRows
            tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
            cellClassName="p-2 border-1-bottom-gray text-sm"
          >
            <Column body={gmgHoPlu}  header="GMG HO PLU" />
            <Column body={bodyChintaiPlu} header="Chintai PLU" />
            <Column body={viewGmgProductBody} header="Actions" />
          </DataTable>
        </div>
    </div>
  );
}
